import styled from 'styled-components';
import { doodles } from '../../../styles/decor';

export const FooterArea = styled.footer`
    background:
        radial-gradient(700px 300px at 100% 0%, rgba(255, 214, 10, .14), transparent 70%),
        ${doodles('#ffffff', .06)} 0 0 / 220px,
        var(--salato-red-strong);
    color:#fff;
    border-radius:40px 40px 0 0;
    margin-top:8px;
    box-shadow:0 -12px 40px rgba(200, 20, 27, .18);

    .container{
        max-width:1240px;
        margin:0 auto;
        padding:44px 24px calc(28px + var(--safe-area-bottom));
    }

    .footerTop{
        display:grid;
        grid-template-columns:repeat(3, minmax(0, 1fr));
        gap:16px;
        padding-bottom:36px;
        border-bottom:1px solid rgba(255,255,255,.1);
    }

    .featureItem{
        display:flex;
        align-items:flex-start;
        gap:12px;

        strong{
            display:block;
            font-size:16px;
        }

        span{
            display:block;
            margin-top:2px;
            font-size:14px;
            color:rgba(255,255,255,.78);
        }
    }

    .featureDot{
        flex-shrink:0;
        width:10px !important;
        height:10px;
        margin-top:6px !important;
        border-radius:50%;
        background:var(--salato-yellow);
        box-shadow:0 0 0 4px rgba(255, 214, 10, .25);
    }

    .footerMain{
        display:grid;
        grid-template-columns:1.4fr 1fr 1.2fr 1.1fr;
        gap:32px;
        padding:40px 0;
    }

    .footerBrand{
        img{
            width:120px;
            height:auto;
            display:block;
        }

        p{
            margin:14px 0 0;
            max-width:280px;
            color:rgba(255,255,255,.65);
            font-size:14px;
            line-height:1.6;
        }
    }

    .footerCol{
        display:flex;
        flex-direction:column;
        gap:10px;
        font-size:14px;

        strong{
            margin-bottom:4px;
            font-size:13px;
            letter-spacing:.12em;
            text-transform:uppercase;
            color:var(--salato-yellow);
        }

        a,
        span{
            color:rgba(255,255,255,.78);
            text-decoration:none;
            overflow-wrap:anywhere;
        }

        a{
            transition:color .2s ease, transform .2s ease;

            &:hover{
                color:#fff;
                transform:translateX(3px);
            }
        }
    }

    .footerBottom{
        padding-top:24px;
        border-top:1px solid rgba(255,255,255,.1);

        p{
            margin:0;
            font-size:13px;
            color:rgba(255,255,255,.5);
        }
    }

    @media (max-width:900px){
        .footerTop{ grid-template-columns:1fr; }

        .footerMain{
            grid-template-columns:1fr 1fr;
            gap:28px;
        }

        .footerBrand{ grid-column:1 / -1; }
    }

    @media (max-width:520px){
        .container{ padding:36px 18px calc(96px + var(--safe-area-bottom)); }

        .footerMain{ grid-template-columns:1fr; }
    }
`;
